module.exports = __webpack_public_path__ + "img/1750213429486-执行人员工作照片示例.9185a006.png";